import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { Container, Row, Form, Button, Offcanvas, Image } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import {ReactComponent as UsersSvg} from './../../assets/images/i-users.svg';
import { toast } from 'react-toastify';
import master from "../../actions/master";
import auth from "../../actions/auth";
import Select from 'react-select';
const process = require('./../../assets/images/regis-process.png');

export default function Register() {
   const navigate = useNavigate();
   const formRef = useRef();
   const [passType, setPassType] = useState(true);
   const [nonNasabah, setNonNasabah] = useState(false);
   const [cpassType, setCpassType] = useState(true);
   const [show, setShow] = useState(false);
   const [showResp, setShowResp] = useState(false);
   const [prov, setProv] = useState([]);
   const [cities, setCitites] = useState([]);
   const [district, setDistrict] = useState([]);
   const [village, setVillage] = useState([]);
   const [partner, setPartner] = useState([]);
   const [valJenis, setValJenis] = useState('BSU');
   const [partners, setPartners] = useState([]);
   const [loading, setLoading] = useState(false);

   const dataJenis = [
      {code: 'BSU', name: 'BSU'},
      {code: 'Instansi', name: 'Instansi'},
      {code: 'Swasta', name: 'Swasta'},
      {code: 'Lainnya', name: 'Lainnya'},
   ]
   const [form, setForm] = useState({
      nama: '',
      no_handphone: '',
      email: '',
      jenis_non_perorangan: valJenis,
      provinces: '',
      cities: '',
      district: '',
      villages: '',
      address: '',
      jumlah_keluarga: '',
      mitra: '',
      password: '',
      cpassword: ''
   });

   const handleClose = () => setShow(false);
   const handleShow = () => setShow(true);
   const handleCloseResp = () => setShowResp(false);
   const handleShowResp = () => setShowResp(true);
   const handleClick = (urls) => {
     navigate(urls);
   };
   const [load, setLoad] = useState(false)

   const fetchPartners = (search = "") => {
      setLoading(true);
      const query = search ? `?filter[name]=${search}` : "";
      master.actions
        .get_partner(query)
        .then((res) => {
          const options = res.data.map((partner) => ({
            value: partner.id,
            label: partner.name,
          }));
          setPartner(res.data);
          setPartners(options);
          setLoading(false);
        })
        .catch(() => setLoading(false));
    };

   useEffect(() => {
      master.actions.get_province().then((res) => {
         setProv(res.data);
      });
      fetchPartners(); // Load initial data

      // master.actions.get_partner().then((res) => {
      //    setPartner(res.data);
      // });
   },[]);

    // Handle real-time search input
  const handleInputChange = (inputValue) => {
      fetchPartners(inputValue); // Fetch based on search input
   };

   // Handle selection change
   const handleChange = (selectedOption) => {
      setForm({ ...form, mitra: String(selectedOption?.value) || "" });
   };

   const changeProvince = (d) =>{
      setForm({...form, ...{provinces: d, cities: '', district: '', villages: ''}})
      master.actions.get_cities(d).then((res) => {
         setCitites(res.data);
      });
   }

   const changeCities = (d) =>{
      setForm({...form, ...{cities: d,  district: '', villages: ''}})
      master.actions.get_district(d).then((res) => {
         setDistrict(res.data);
      });
   }

   const changeDistrict = (d) =>{
      setForm({...form, ...{district: d, villages: ''}})
      master.actions.get_village(d).then((res) => {
         setVillage(res.data);
      });
   }

   const changeVillage = (d) =>{
      setForm({...form, ...{villages: d}})
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      setLoad(true);
      let data = {
         role : 'client',
         type : nonNasabah ? 'organization' : 'person',
         organization_type : dataJenis.filter((a,b) => a.name === valJenis)[0].code,
         name : form.nama,
         phone : form.no_handphone,
         email : form.email,
         address : form.address,
         province_id : form.provinces,
         city_id : form.cities ,
         district_id : form.district,
         village_id : form.villages,
         total_family_member : form.jumlah_keluarga ? form.jumlah_keluarga : 0,
         partner_id : form.mitra,
         password : form.password,
         password_confirmation : form.cpassword,
      }

      auth.actions.register(data).then((res) => {
         setLoad(false)
         handleShowResp();
         setForm({
            nama: '',
            no_handphone: '',
            email: '',
            jenis_non_perorangan: valJenis,
            provinces: '',
            cities: '',
            district: '',
            villages: '',
            address: '',
            jumlah_keluarga: '',
            mitra: '',
            password: '',
            cpassword: ''
         })

         formRef.current.reset();
      }).catch((err) => {
         toast.error(err.message);
         setLoad(false)
      });
   }

  return (
   <Container>
      <Row className="section justify-content-center">
         <div className="fixed-top bg-white header">
            <div className="text-center fw-semibold">
                Daftar Akun
            </div>
            <Button className="btn btn-icon btn-success btn-sm btn-radius btn-nav-back" onClick={() => handleClick('/')}>
                <i className="ph-arrow-left text-light"></i>
            </Button>
        </div>
         <div className="mt-100 px-4">
            <Form onSubmit={(e) => handleSubmit(e)} ref={formRef}>  
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Jenis Nasabah*</Form.Label>
                  <Form.Select size="sm" onChange={()=>setNonNasabah(!nonNasabah)} required>
                     <option value="person">Perorangan</option>
                     <option value="organization">Non Perorangan</option>
                  </Form.Select>
               </Form.Group>
               { nonNasabah ?
                  <div onClick={()=>handleShow()}>
                     <Form.Group className="mb-3">
                        <Form.Label className="mb-2">Jenis Nasabah Non Perorangan*</Form.Label>
                        <div className="position-relative">
                           <Form.Control size="sm" value={valJenis} disabled className="bg-white" required/>
                           <Form.Text className="input-icon">
                              <i className="ph-caret-down fw-bold"></i>
                           </Form.Text>
                        </div>
                     </Form.Group> 
                  </div> :
                  null
               }
               <Offcanvas show={show} onHide={handleClose} placement="bottom" className="h-auto">
                  <Offcanvas.Header closeButton>
                     <Offcanvas.Title>Jenis Nasabah Non Perorangan</Offcanvas.Title>
                  </Offcanvas.Header>
                  <Offcanvas.Body className="p-0">
                     {dataJenis.map((e,key) =>{
                         return <div key={key} className="d-flex align-items-center bg-light p-3 border-bottom justify-content-between">
                           <label htmlFor={e.code}>
                              <div className="d-flex align-items-center">
                                 <div className="btn-success p-2 btn-radius">
                                    <UsersSvg/>
                                 </div>
                                 <div className="mx-3">{e.name}</div>
                              </div>
                           </label>
                           <input type="radio" name="select_jenis_np" defaultChecked={e.name === valJenis} className="radio-canvas"
                              id={e.code} onClick={() => setValJenis(e.name)}/>
                        </div>
                     })
                     }
                  </Offcanvas.Body>
               </Offcanvas>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Nama*</Form.Label>
                  <Form.Control type="text" placeholder="Nama" defaultValue={form.nama} onChange={(e) => setForm({...form, ...{nama: e.target.value}})} required/>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">No. Handphone (WhatsApp)*</Form.Label>
                  <Form.Control type="number" placeholder="No. handphone (WA)" defaultValue={form.no_handphone} onChange={(e) => setForm({...form, ...{no_handphone: e.target.value}})} required/>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Email</Form.Label>
                  <Form.Control type="email" placeholder="Email" defaultValue={form.email} onChange={(e) => setForm({...form, ...{email: e.target.value}})}/>
                  <small className="text-smooth ts-sm"><i>Jika tidak mempunyai email, kosongkan email</i></small>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Provinsi*</Form.Label>
                  <Form.Select 
                     size="sm" 
                     defaultValue={form.provinces} 
                     onChange={(e) => changeProvince(e.target.value)}
                     required
                  >
                     <option value=''>Pilih</option>
                     { prov && prov.map((e, key) => {
                           return <option value={e.code} key={key}>{e.name}</option>
                        })
                     }
                  </Form.Select>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Kota/Kabupaten*</Form.Label>
                  <Form.Select 
                     size="sm" 
                     disabled={form.provinces === ''} 
                     defaultValue={form.cities} 
                     onChange={(e) => changeCities(e.target.value)}
                     required
                  >
                     <option value='' selected={form.provinces === ''}>Pilih</option>
                     { cities && cities.map((e, key) => {
                           return <option value={e.code} key={key}>{e.name}</option>
                        })
                     }
                  </Form.Select>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Kecamatan*</Form.Label>
                  <Form.Select 
                     size="sm" 
                     disabled={form.cities === '' || form.provinces === ''} 
                     defaultValue={form.district} 
                     onChange={(e) => changeDistrict(e.target.value)}
                     required
                  >
                     <option value='' selected={form.cities === '' || form.provinces === ''}>Pilih</option>
                     { district && district.map((e, key) => {
                           return <option value={e.code} key={key}>{e.name}</option>
                        })
                     }
                  </Form.Select>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Kelurahan/Desa*</Form.Label>
                  <Form.Select 
                     size="sm" 
                     disabled={form.district === '' || form.cities === '' || form.provinces === ''} 
                     defaultValue={form.villages} 
                     onChange={(e) => changeVillage(e.target.value)}
                     required
                  >
                     <option value='' selected={form.district === '' || form.cities === '' || form.provinces === ''}>Pilih</option>
                     { village && village.map((e, key) => {
                           return <option value={e.code} key={key}>{e.name}</option>
                        })
                     }
                  </Form.Select>
               </Form.Group>
               <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Alamat Kantor*</Form.Label>
                  <textarea placeholder="Tulis alamat detail" className="form-control" rows={5} onChange={(e) => setForm({...form, ...{address: e.target.value}})} required></textarea>
               </Form.Group>
               { !nonNasabah ?
                  <Form.Group className="mb-3">
                     <Form.Label className="mb-2">Jumlah Anggota Keluarga yg tinggal bersama*</Form.Label>
                     <Form.Control type="number" size="sm" value={form.jumlah_keluarga} className="bg-white" placeholder="Jumlah orang" onChange={(e) => setForm({...form, ...{jumlah_keluarga: e.target.value}})} required/>
                  </Form.Group> : 
                  null
               }

               <div className="mb-3">
                  <label className="mb-2">Pilih Mitra*   <small className="text-muted"> (Ketik jika tidak muncul dalam list)</small>
                  </label>
                  <Select
                     options={partners}
                     isSearchable
                     placeholder="Cari Mitra..."
                     classNamePrefix="selectmitra"
                     onInputChange={handleInputChange} // Real-time search
                     onChange={handleChange} // Update form state on select
                     isClearable // Allow clearing the selection
                     isLoading={loading} // Show loading indicator
                  />
               </div>
               {/* <Form.Group className="mb-3">
                  <Form.Label className="mb-2">Pilih Mitra*</Form.Label>
                  <Form.Select size="sm" onChange={(e) => setForm({...form, ...{mitra: e.target.value}})} required>
                     <option value=''>Pilih</option>
                     { partner && partner.map((e, key) => {
                           return <option value={e.id} key={key}>{e.name}</option>
                        })
                     }
                  </Form.Select>
               </Form.Group> */}
               <Form.Group className="mb-3" controlId="formBasicPassword">
                  <Form.Label className="mb-2">Kata Sandi*</Form.Label>
                  <div className="position-relative">
                     <Form.Control type={passType ? 'password' : 'text'} placeholder="Kata sandi" onChange={(e) => setForm({...form, ...{password: e.target.value}})} required/>
                     <Form.Text className="input-icon" onClick={()=>setPassType(!passType)}>
                        {passType ?
                           <i className="ph-eye text-success-bold fw-bold"></i> :
                           <i className="ph-eye-slash text-success-bold fw-bold"></i>
                        }
                     </Form.Text>
                  </div>
                  { form.password.length < 5 && form.password.length ?
                     <small className="text-danger">Password minimal 5 karakter</small> : null
                  }
               </Form.Group>
               <Form.Group className="mb-3" controlId="formBasicPasswordConfirm">
                  <Form.Label className="mb-2">Ulangi Kata Sandi*</Form.Label>
                  <div className="position-relative">
                     <Form.Control 
                        type={cpassType ? 'password' : 'text'} 
                        placeholder="Ulangi kata sandi" 
                        onChange={(e) => setForm({...form, ...{cpassword: e.target.value}})}
                        required
                     />
                     <Form.Text className="input-icon" onClick={()=>setCpassType(!cpassType)}>
                        {cpassType ?
                           <i className="ph-eye text-success-bold fw-bold"></i> :
                           <i className="ph-eye-slash text-success-bold fw-bold"></i>
                        }
                     </Form.Text>
                  </div>
                  { form.cpassword.length && form.cpassword !== form.password ?
                     <small className="text-danger">Password tidak sesuai</small> : null
                  }
               </Form.Group>

               <div className="my-4">
                  <div className="text-center text-muted">
                     <span className="me-1">Sudah punya akun?</span>
                     <u className="text-success-bold" onClick={() => handleClick('/')}>Masuk disini</u>
                  </div>
               </div>
               <div className="d-grid gap-2 mb-5">
                  <Button disabled={load} className="btn-auth rounded-pill p-3" variant="success" type="submit" >
                     {load ? <i class="ph-spinner spinner text-light"></i> : 'SUBMIT'}
                  </Button>
               </div>
            </Form>
         </div>
      </Row>

      <Offcanvas show={showResp} onHide={handleCloseResp} placement="bottom" className="h-auto">
         <Offcanvas.Header closeButton>
            <Offcanvas.Title></Offcanvas.Title>
         </Offcanvas.Header>
         <Offcanvas.Body className="py-5">
            <div className="my-3 text-center">
               <Image src={process}/>
            </div>
            <div className="my-5">
               <div className="text-center">
                  <span className="fw-bold">Yeay Selamat, {' '}</span>
                  kamu berhasil mendaftarkan akun. Tunggu petugas memverifikasi
                  akunmu agar kamu bisa login.
               </div>
            </div>

            <div className="d-grid gap-2 mt-4">
               <Button className="btn-auth rounded-pill p-3" variant="success" onClick={() => handleClick('/')} >
                  OK, MENGERTI!
               </Button>
            </div>
         </Offcanvas.Body>
      </Offcanvas>
   </Container>
  );
}